import { get, post } from '../service';
import { UrlBuilder } from '../urlBuilder';

export const extractionDocuments = async (listId) => {
  const builder = new UrlBuilder(`/extractions/extract-documents/${listId}`);
  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getExtractionData = async (listId) => {
  const builder = new UrlBuilder(`/extractions/get-extraction-data/${listId}`);
  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getZones = async () => {
  const builder = new UrlBuilder(`/areas/get-zones`);

  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getPrecincts = async (zoneId) => {
  const builder = new UrlBuilder(`/areas/get-precincts/${zoneId}`);

  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getDevelopments = async () => {
  const builder = new UrlBuilder(`/developments/get-developments`);

  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const confirmInfo = async (payload) => {
  const builder = new UrlBuilder(`/developments/confirm-info`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
